<template>
  <div class="grid">
	<div class="col-12 lg:col-12">
		<Toolbar class="mb-1">
			<template v-slot:start>
				<div class="mt-3 ml-5 flex align-items-center">
				</div>
			</template>
			<template v-slot:end>
				<Button type="button" label="Descargar Informe Preoperacional" icon="pi pi-upload" :loading="loader_pre" @click="toggle" class="p-button-raised p-button-success mr-2" aria-haspopup="true" aria-controls="overlay_menu" />
        		<Menu ref="menu" id="overlay_menu" :model="items" :popup="true" />
			</template>
		</Toolbar>
	</div>
	<div class="field col-12 text-center">
		<DataTable :value="inspeccion_vehicular" let-i="rowIndex" v-model="table_documentos" :paginator="true" :rows="5" responsiveLayout="scroll">
			<Column field="original_checklist_item_name" header="Categoria" :sortable="false">
				<template #body="slotProps">
					{{slotProps.data.category_name ?? ''}}
				</template>
			</Column>
			<Column field="fecha" header="Fecha" :sortable="false">
				<template #body>
					{{ fecha_inspeccion.split(' ')[0] ?? ''}}
				</template>
			</Column>
			<Column field="comment" header="Observaciones" :sortable="false">
				<template #body="slotProps">
					{{slotProps.data.category_comment}}
				</template>
			</Column>
			<Column field="rate" header="Calificación" :sortable="false">
				<template #body="slotProps">
					<Rating :modelValue="slotProps.data.category_rate" :readonly="true" :cancel="false" />
				</template>
			</Column>
			<Column field="url" header="Imagenes" :sortable="false">
				<template #body="slotProps">
					<template v-if="slotProps.data.category_images.length>0">
						<Button icon="pi pi-images" class="p-button-rounded button-orange p-button-outlined m-1" :loading="loading" title="Ver imagenes" @click="verImg(slotProps.data)" />
					</template>
					<template v-else>
						<Button icon="pi pi-images" class="p-button-rounded button-orange p-button-outlined m-1" disabled="disabled" :loading="loading" title="Ver imagenes" @click="verImg(slotProps.data)" />
					</template>
				</template>
			</Column>
			<Column field="url" header="Sub Categorias" :sortable="false">
				<template #body="slotProps">
						<Button icon="pi pi-list" class="p-button-rounded button-sewayblue p-button-outlined m-1" :loading="loading" title="Ver subcategorias calificadas" @click="verItems(slotProps.data)" />
				</template>
			</Column>
		</DataTable>
	</div>
	<Dialog v-model:visible="modal_img" :style="{width: '800px'}" header="Imagenes" :modal="true" class="p-fluid">
			<div class="field formgrid grid">
				<div class="field col-12">
					<Galleria :value="img_checklist" :responsiveOptions="galleriaResponsiveOptions" class="mt-1" :numVisible="4" :circular="true">
						<template #item="slotProps">
							<img :src="slotProps.item.blob" :alt="slotProps.item.original_url" style="width: 60%; display: block" />
						</template>
						<template #thumbnail="slotProps">
							<img :src="slotProps.item.blob" :alt="slotProps.item.original_url" style="width: 10%; display: block" />
						</template>
					</Galleria>
				</div>
			</div>
			<template #footer>
				<Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modal_img = false"/>
			</template>
		</Dialog>
		<Dialog v-model:visible="modal_detalle" :style="{width: '800px'}" :header="tittle_item" :modal="true" class="p-fluid">
			<div class="field formgrid grid">
				<div class="field col-12">
					<DataTable :value="detalle_items" let-i="rowIndex" v-model="detalle_items" :paginator="true" :rows="5" responsiveLayout="scroll">
						<Column field="original_checklist_item_name" header="Sub Categoria" :sortable="false">
							<template #body="slotProps">
								{{slotProps.data.title ?? ''}}
							</template>
						</Column>
						<Column field="comment" header="Calificación" :sortable="false">
							<template #body="slotProps">
								{{slotProps.data.rate_description}}
							</template>
						</Column>
						<Column field="rate" header="Calificación" :sortable="false">
							<template #body="slotProps">
								<Rating :modelValue="slotProps.data.rate" :readonly="true" :cancel="false" /><br>
							</template>
						</Column>
					</DataTable>
				</div>
			</div>
			<template #footer>
				<Button label="Cerrar" icon="pi pi-times" class="p-button-text" @click="modal_detalle = false"/>
			</template>
		</Dialog>
  </div>
</template>

<script>
import Rating from 'primevue/rating';
export default {
	data() {
		return {
			message: [],
			table_documentos: null,
			value: null,
			modal_img: false,
			modal_detalle: false,
			loader_pre: false,
			img_checklist: [],
			galleriaResponsiveOptions: [
                {
                    breakpoint: "724px",
                    numVisible: 5,
                },
                {
                    breakpoint: "660px",
                    numVisible: 4,
                },
                {
                    breakpoint: "168px",
                    numVisible: 3,
                },
                {
                    breakpoint: "160px",
                    numVisible: 1,
                },
            ],
			loading: false,
			detalle_items: [],
			items: [
                {
                    label: 'PDF',
                    icon: 'pi pi-file-pdf',
					command: () => {
                        this.downloadPreoperacional('pdf');
                    }
                },
                {
                    label: 'XLSX',
                    icon: 'pi pi-file-excel',
					command: () => {
                        this.downloadPreoperacional('xlsx');
                    }
                },
                {
                    label: 'CSV',
                    icon: 'pi pi-file-excel',
					command: () => {
                        this.downloadPreoperacional('csv');
                    }
                }
            ],
			tittle_item: ''
		}
	},
	props: ['inspeccion_vehicular','IdCustomer','id_deliverie','datos_vehiculo','loader','num_movimiento','fecha_inspeccion'],
  	mounted(){
		// this.loadGeneradores();
	},
	methods:{
		toggle(event) {
            this.$refs.menu.toggle(event);
        },
		verImg(data){
			console.log(data);
			var _that = this;
			this.loading = true;
			var url = 'get_image_checklist';
			window.api.call('post', url, {category_images: data.category_images}).then( function(response) {
				if(response.status == 200){
					if (response.data.cuantos == 0) {
						_that.$toast.add({severity:'error', summary: 'No hay imagenes', detail:'No se han subido imagenes a este item', life: 4000});
					}else{
						_that.img_checklist = response.data.response_seway.images;
						// _that.img_checklist = response.data.data;
						_that.modal_img = true;
					}
					
					_that.loading = false;
				}
			}).catch(function (err) {
				console.log(err);

				_that.loading = false;
				if (err.status == 414){
					_that.$toast.add({severity:'error', summary: 'Ocurrio un error', detail: err.message, life: 4000});
				}
			});
		},
		verItems(data){
			this.modal_detalle = true;
			this.detalle_items = data.details;
			this.tittle_item = data.category_name;
		},
		async downloadPreoperacional(formato){
			this.loader_pre = true;
            var _that = this;
            axios({
            url: '/generarpdfpreoperacional',
            method: 'POST',
            data: {id_deliverie: this.id_deliverie,inspeccion_vehicular: this.inspeccion_vehicular,datos_vehiculo: this.datos_vehiculo,id_customer: this.IdCustomer,num_movimiento: this.num_movimiento,formato: formato},
            responseType: 'blob',
            }).then((response) => {
				var nombrearchivo = this.datos_vehiculo.placa+'.'+formato;
                _that.forceFileDownloadQr(response,nombrearchivo);
				_that.loader_pre = false;
            }).catch((error) => {
				console.error('Error generating PDF:', error);
				_that.loader_pre = false;
				_that.$toast.add({severity:'error', summary: 'Ocurrio un error', detail: 'comuniquese con un admin', life: 4000});
				// Aquí puedes mostrar un mensaje de error al usuario si es necesario
			});
        },
		forceFileDownloadQr(response,nombrearchivo){
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nombrearchivo); //or any other extension
            document.body.appendChild(link);
            link.click();
			this.loader_pre = false;
        },
		
	},
	components:{
		'Rating' : Rating
	}
};
</script>
<style scoped>
.button-orange{
    background: #EB7D10;
    color: white;
}
.button-sewayblue{
    background: #0A354E;
    color: white;
}
.button-sewayblue:hover{
    background: #0c4f77;
    color: white;
}
</style>